export const mapTypes = [
    {
        value: "map",
        title: "Map"
    },
    {
        value: "graph",
        title: "Graph"
    }
]